import { useStorePlanningWeek } from '@gozoki/api'
import { useState } from 'react'
import { ChevronRightRoundIcon } from './icons/LayerIcon'
import { PlanningWeekModal } from './PlanningWeekModal'
import { DashboardCard } from './ui/DashboardCard'
import { PlanningGrid } from './planning/PlanningGrid'
import { PlanningLegend } from './planning/PlanningLegend'
import { CalendarIcon } from './planning/planning-icons'

export function PlanningWeekCard() {
  const { data, isLoading } = useStorePlanningWeek()
  const [isDetailOpen, setIsDetailOpen] = useState(false)
  const openDetail = () => setIsDetailOpen(true)

  // Sans bordure : `border-0` annule celle de `DashboardCard` (même padding, même rendu).
  return (
    <DashboardCard className="min-h-0 min-w-0 flex-1 border-0 bg-[#F0EDE2]" onOpen={openDetail}>
      <div className="flex h-[40px] items-center gap-[12px]">
        <div className="flex shrink-0 items-center gap-[8px]">
          <span className="flex size-[40px] items-center justify-center rounded-[12px] bg-[#F9F8F1] text-[#4F6A47]">
            <CalendarIcon />
          </span>
          <h2 className="font-brand text-[22px] leading-[26px] font-semibold whitespace-nowrap text-[#4F6A47] uppercase">
            Planning semaine en cours
          </h2>
        </div>

        {/* Ouvre le détail plein écran (modale). */}
        <button
          type="button"
          aria-label="Ouvrir le détail du planning"
          onClick={openDetail}
          className="shrink-0 cursor-pointer text-[#4F6A47]"
        >
          <ChevronRightRoundIcon />
        </button>

        <span className="h-px min-w-0 flex-1 bg-[#0000000F]" />

        <PlanningLegend />
      </div>

      {data ? (
        <PlanningGrid days={data.days} centerOnNow />
      ) : (
        <div className="flex min-h-0 flex-1 items-center justify-center text-sm text-[#8A8676]">
          {isLoading ? 'Chargement…' : 'Aucune donnée'}
        </div>
      )}

      {isDetailOpen ? <PlanningWeekModal onClose={() => setIsDetailOpen(false)} /> : null}
    </DashboardCard>
  )
}
